import { Controller } from "@hotwired/stimulus"

// Turbo Frame navigations promoted to a visit (`data-turbo-action="advance"`)
// update the URL but keep the previous <title>: the frame content carries it.
export default class extends Controller {
  static values = { title: String }

  connect () {
    if (this.titleValue) document.title = this.titleValue
  }
}
